import * as S from './TotalAmount.styles';

type TotalAmountProps = {
    total: number;
};

export const TotalAmount = ({ total }: TotalAmountProps) => {
    return (
        <S.TotalPrice>
            <S.Dollar>$</S.Dollar>
            {total?.toFixed(2)}
        </S.TotalPrice>
    );
};
